<template>
  <div
    ref="kt_modal_revenda_consultar"
    data-bs-backdrop="static"
    class="modal fade modal-overlay"
    tabindex="-1"
    id="kt_modal_revenda_consultar"
  >
    <div
      class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-body p-0">
          <ConsultarRevenda
            ref="ConsultarRevenda"
            :modal="true"
            :contato="contato"
            @selecionarRevenda="selecionarRevenda"
            @contatoRevenda="contatoRevenda"
            @fecharRevenda="modalConsultarRevenda"
          ></ConsultarRevenda>
        </div>
      </div>
    </div>
  </div>
  <div v-if="exibirModalContatoRevenda" class="modal-overlay">
    <div
      ref="kt_modal_revenda_contato"
      data-bs-backdrop="static"
      class="modal fade"
      data-bs-keyboard="false"
      v-modal-drag
      tabindex="-1"
      id="kt_modal_revenda_contato"
    >
      <div
        class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable"
      >
        <div class="modal-content">
          <div class="modal-header">
            <div class="modal-title d-flex align-items-center">
              <span class="svg-icon svg-icon-1 svg-icon me-3 lh-0">
                <inline-svg
                  src="media/icons/duotune/communication/com005.svg"
                />
              </span>
              <h3 class="fw-bold m-0 text-gray-800">Contato</h3>
            </div>
            <div
              class="btn btn-icon btn-sm btn-active-light-primary"
              data-bs-dismiss="modal"
              @click="modalContatoRevenda(false)"
            >
              <span class="svg-icon svg-icon-1 svg-icon lh-0">
                <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
          </div>
          <div class="modal-body">
            <table
              class="table align-middle table-row-dashed fs-6 text-gray-600 fw-bold gy-5 table-hover"
            >
              <tbody>
                <tr>
                  <td class="ps-5">
                    {{ "Nome: " }}
                  </td>
                  <td class="min-w-150px">
                    {{ this.revenda.nome }}
                  </td>
                </tr>
                <tr>
                  <td class="ps-5">
                    {{ "Responsável: " }}
                  </td>
                  <td class="min-w-150px">
                    {{ this.revenda.responsavel }}
                  </td>
                </tr>
                <tr>
                  <td class="ps-5">
                    {{ "Telefone: " }}
                  </td>
                  <td class="min-w-150px">
                    {{ this.revenda.telefone }}
                  </td>
                </tr>
                <tr v-if="this.revenda.fax">
                  <td class="ps-5">
                    {{ "Celular: " }}
                  </td>
                  <td class="min-w-150px">
                    {{ this.revenda.fax }}
                  </td>
                </tr>
                <tr>
                  <td class="ps-5">
                    {{ "Email: " }}
                  </td>
                  <td class="min-w-250px">
                    {{ this.revenda.email }}
                  </td>
                </tr>
                <tr v-if="this.revenda.site">
                  <td class="ps-5">
                    {{ "Site: " }}
                  </td>
                  <td class="min-w-150px">
                    {{ this.revenda.site }}
                  </td>
                </tr>
                <tr>
                  <td class="ps-5">
                    {{ "Endereço: " }}
                  </td>
                  <td>
                    <div class="min-w-250px align-middle">
                      <div>
                        <span class="text-dark text-hover-primary mb-1">
                          {{
                            this.revenda.endereco +
                            ", " +
                            this.revenda.numero +
                            " - " +
                            this.revenda.bairro +
                            " - " +
                            this.revenda.cidade +
                            " - " +
                            this.revenda.uf
                          }}
                        </span>
                        <span class="text-muted fw-bold d-block">
                          {{
                            this.revenda.complemento
                              ? this.revenda.complemento + " "
                              : ""
                          }}
                          {{ "CEP: " + this.revenda.cep }}
                        </span>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <div class="d-flex justify-content-center">
                      <button
                        class="btn btn-sm btn-light-primary"
                        @click="this.enviarSolicitacao(this.revenda)"
                      >
                        Enviar Solicitação
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ConsultarRevenda from "@/views/revenda/revenda/Consultar.vue";
import { hideModal, getOrCreateInstanceModal } from "@/core/helpers/dom";

export default {
  emits: ["selecionarRevenda", "exibirModalRevenda"],
  props: {
    contato: { type: Boolean, required: false, default: false },
  },
  components: {
    ConsultarRevenda,
  },
  methods: {
    modalConsultarRevenda(exibir) {
      if (exibir === false) {
        this.$emit("exibirModalRevenda", false);
      }
    },
    selecionarRevenda(distribuidorMaster) {
      this.$emit("selecionarRevenda", distribuidorMaster);
      this.modalConsultarRevenda(false);
      hideModal(this.$refs.kt_modal_revenda_consultar);
    },
    async contatoRevenda(revenda) {
      try {
        var ret = await this.$store.dispatch("revenda/getRevenda", revenda.id);
        if (ret.Success === true) {
          this.revenda = ret.Data;
          this.modalContatoRevenda(true);
        }
      } catch (error) {
        console.log(error);
      }
    },
    modalContatoRevenda(exibir) {
      this.exibirModalContatoRevenda = exibir;
      if (exibir === true) {
        setTimeout(() => {
          getOrCreateInstanceModal("kt_modal_revenda_contato");
        }, 100);
      }
    },
    enviarSolicitacao(revenda) {
      this.modalContatoRevenda(false);
      hideModal(this.$refs.kt_modal_revenda_contato);
      this.modalConsultarRevenda(false);
      hideModal(this.$refs.kt_modal_revenda_consultar);
      this.$emit("selecionarRevenda", revenda);
    },
  },
  data() {
    return {
      exibirModalContatoRevenda: false,
      revenda: null,
    };
  },
};
</script>

<style></style>
